import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'arrow'
  ],
  modifiers: ['inverse'],
  states: []
}

export default function Link(props) {
  const { href, children, inverse, arrow, gtm = {}, ...rest } = props
  const { gtmClassName = '', dataGTM = {} } = gtm

  return !arrow
    ? <a {...rest} href={href} {...dataGTM} className={`${resolveProps(props, config, 'Link')}${gtmClassName}`}>{children}</a>
    : (
      <div className={`${resolveProps(props, config, 'Link')}`} >
        <a {...rest} className={`mdn-Link-anchor ${gtmClassName}`} href={href} {...dataGTM}>
          <span className="mdn-Link-anchor-label">{children}</span>
          <span className={'mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm'}></span >
        </a>
      </div>
    )
}

Link.propTypes = {
  config: PropTypes.object,
  disabled: PropTypes.bool,
  arrow: PropTypes.bool,
  inverse: PropTypes.bool,
  children: PropTypes.node,
  href: PropTypes.string,
  gtm: PropTypes.object
}
